<!--
 * @Author: zhangyaowen zhangyaowen_520@163.com
 * @Date: 2022-05-24 15:56:29
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @LastEditTime: 2022-06-13 11:45:21
 * @FilePath: \smart-community\src\components\compnment\HDropDown.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="HDropDown">
    <template v-if="firstBtn.length <= 2">
      <el-button
        :disabled="item.disabled"
        v-for="item in firstBtn"
        :key="item"
        :type="item.type"
        @click="btnClick(item.methodsName, item.params)"
        >{{ item.name }}</el-button
      >
    </template>
    <template v-else>
      <el-button
        :disabled="dropdownData[0].disabled"
        :type="dropdownData[0].type"
        @click="btnClick(dropdownData[0].methodsName)"
        >{{ dropdownData[0].name }}</el-button
      >
      <el-dropdown>
        <el-button><span>操作</span> </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="item in firstBtn"
              :key="item"
              @click="btnClick(item.methodsName, item.params)"
              ><span :style="{ color: getColor(item.type) }">
                {{ item.name }}</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </template>
  </div>
</template>
<script>
import { defineComponent, watchEffect, reactive, toRefs, computed } from "vue";
export default defineComponent({
  name: "HDropDown",
  props: {
    dropdownData: {
      type: Object,
      default: []
    }
  },
  emits: ["editOrgan"],
  setup(props, context) {
    const data = reactive({
      firstBtn: {},
      colorList: {
        primary: "#294a7c",
        success: "#49e0fb",
        danger: "#f55252",
        warning: "#fa930e",
        info: "#dddddd"
      },
      getColor: "#294a7c"
    });
    watchEffect(() => {
      if (props.dropdownData.length > 2) {
        data.firstBtn = props.dropdownData.filter((item, index) => {
          if (index !== 0) {
            return item;
          }
        });
        // props.dropdownData[0];
      }
    });
    const getColor = computed(() => {
      return function (val) {
        return data.colorList[val];
      };
    });
    const btnClick = (method, params) => {
      console.log(method, params);
      context.emit(`${method}`, params);
    };
    return {
      ...toRefs(data),
      getColor,
      btnClick
    };
  }
});
</script>
<style lang="scss" scoped>
.HDropDown {
  .el-dropdown {
    margin-left: 16px;
    .el-button {
      background-color: #388ff3;
      color: #fff;
    }
  }
}
</style>
